import { render, staticRenderFns } from "./GeneralMessage.vue?vue&type=template&id=33330dca&"
import script from "./GeneralMessage.vue?vue&type=script&lang=js&"
export * from "./GeneralMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33330dca')) {
      api.createRecord('33330dca', component.options)
    } else {
      api.reload('33330dca', component.options)
    }
    module.hot.accept("./GeneralMessage.vue?vue&type=template&id=33330dca&", function () {
      api.rerender('33330dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/GeneralMessage.vue"
export default component.exports